import { goto } from "./product.goto";
export * from "./ProductRoutes";

export const productRoute = {
  goto: goto,
};
